import { useQuizContext } from 'store/QuizStore'
import { useTransition } from 'react-spring'

import AppHeader from 'components/AppHeader'
import LandscapeModal from 'components/LandscapeModal'
import Intro from 'components/Intro'
import Quiz from 'components/Quiz'
import ResultMessage from 'components/ResultMessage'
import Results from 'components/Results'

import { Root, ScreenWrapper } from './App.styled'

// import bgX1 from 'assets/bg.png'
// import bgX2 from 'assets/bg@2x.png'
// import bgX3 from 'assets/bg@3x.png'

const screens = {
  intro: props => <Intro {...props}></Intro>,
  quiz: props => <Quiz {...props}></Quiz>,
  message: props => <ResultMessage {...props}></ResultMessage>,
  results: props => <Results {...props}></Results>,
}

function App() {
  const { currentScreen } = useQuizContext()

  const screenTransition = useTransition(currentScreen, null, {
    initial: { transform: `translate(0%, 0)` },
    from: { transform: `translate(100%, 0)` },
    enter: { transform: `translate(0%, 0)` },
    leave: { transform: `translate(-100%, 0)` },
  })
  return (
    <Root>
      {/* <Background show={currentScreen !== 'intro'}>
        <img src={bgX1} srcSet={`${bgX2} 2x, ${bgX3} 3x`} alt="" />
      </Background> */}
      <AppHeader></AppHeader>
      {screenTransition.map(({ item, key, props }) => (
        <ScreenWrapper key={key} style={props}>
          {screens[item]()}
        </ScreenWrapper>
      ))}
      <LandscapeModal></LandscapeModal>
    </Root>
  )
}

export default App
